import commonApi from './CommonApi.js';
import uploadApi from './UploadApi.js';

var qs = require('querystring');

export default {
	getAll: async (parameter) => {
		return await commonApi().get('/v1/chats/getAll', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	exportToExcelList: async (parameters) => {
		return await commonApi().get('/v1/chats/exportToExcelList',
			//{ params: parameters, responseType: 'blob' }
			{
				params: parameters,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				},
				responseType: 'blob'
			})
			.then((response) => {
				var fileName = 'Admin Chats.xlsx';
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', fileName);
				document.body.appendChild(fileLink);
				fileLink.click();
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getAdminChatUsers: async (parameter) => {
		return await commonApi().get('/v1/chats/getAdminChatUsers', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	adminChatUsersExportToExcelList: async (parameters) => {
		return await commonApi().get('/v1/chats/adminChatUsersExportToExcelList',
			//{ params: parameters, responseType: 'blob' }
			{
				params: parameters,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				},
				responseType: 'blob'
			})
			.then((response) => {
				var fileName = 'Admin Chat - Users.xlsx';
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', fileName);
				document.body.appendChild(fileLink);
				fileLink.click();
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getDetail: async (parameters) => {
		return await commonApi().get('/v1/chats/getDetail', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
				return error.response;
			});
	},
	getChatMessages: async (parameters) => {
		return await commonApi().get('/v1/chats/getChatMessages', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getChatUsers: async (parameters) => {
		return await commonApi().get('/v1/chats/getChatUsers', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getMemberList: async (parameters) => {
		return await commonApi().get('/v1/chats/getMemberList', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	start: async (viewModel) => {
		return await commonApi().post('/v1/chats/start', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	postMessage: async (viewModel) => {
		return await commonApi().post('/v1/chats/postMessage', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	receiveEmailUpdate: async (viewModel) => {
		return await commonApi().post('/v1/chats/receiveEmailUpdate', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	deleteMessage: async (viewModel) => {
		return await commonApi().post('/v1/chats/deleteMessage', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	setMemberRole: async (viewModel) => {
		return await commonApi().post('/v1/chats/setMemberRole', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	addMember: async (viewModel) => {
		return await commonApi().post('/v1/chats/addMember', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	uploadAttachment: async (formData) => {
		return await uploadApi().post('/v1/chats/uploadAttachment',
				formData, {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'multipart/form-data'
					}
				})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	downloadAttachment: async (parameters) => {
		return await commonApi().get('/v1/chats/downloadAttachment', { params: parameters, responseType: 'blob' })
			.then((response) => {
				var fileName = parameters.fileName;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', fileName);
				document.body.appendChild(fileLink);
				fileLink.click();
			})
			.catch((error) => {
				console.log(error.response);
			});
	}
}